<template>
  <div id="paginaPunteggiMinistero">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">
      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Punteggi Ministero</b-card-title>
              <b-card-text class="mb-0"> Teatro Coccia </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id="dropAnni" ref="dropAnni" :query="queryAnni" :dataSource="anniData"
                  :index="anniIndex" :fields="anniFields" :change="onAnnoChange" v-model="annoCorrente"
                  placeholder="Seleziona un Anno"></ejs-dropdownlist>
              </b-col>

              <b-col xl="12" md="12" class="text-right mt-1" v-show="showButtonCreatePunteggi">
                <ejs-button id="creaPunteggiMinisteroButton" cssClass="e-flat"
                  @click.native="creaPunteggiMinisteroButton()">CREA PUNTEGGI MINISTERO PER L'ANNO SELEZIONATO
                </ejs-button>
              </b-col>

              <b-col xl="12" md="12" class="pt-1 text-center" v-show="loading">
                <b-spinner label="Loading..."></b-spinner>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col xl="12" md="12" class="pt-1">
        <div id="TabParent">
          <b-tabs ref="tabA" v-model="tabAIndex" v-show="showTabsPunteggi">
            <b-tab title="PUNTEGGI MINISTERO PREVENTIVO" @click="tabClicked('tab01')">
              <b-row class="match-height">
                <b-col xl="12" md="12">
                  <h3>&nbsp</h3>
                  <h3>TABELLA QUALITA' ARTISTICA - PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Tabella Qualità Artistica</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>

                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevQualDirezArt" class="h5">Qualità della direzione artistica</label>
                          <ejs-numerictextbox id="prevQualDirezArt" v-model="punteggiMinisteroActiveData.prevQualDirezArt
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Qualità della direzione artistica"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevQualPersArt" class="h5">Qualità professionale del personale artistico e/o degli artisti ospitati</label>
                          <ejs-numerictextbox id="prevQualPersArt" v-model="punteggiMinisteroActiveData.prevQualPersArt
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Qualità professionale del personale artistico e/o degli artisti ospitati"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevQualArtProgetto" class="h5">Qualità artistica del progetto</label>
                          <ejs-numerictextbox id="prevQualArtProgetto" v-model="punteggiMinisteroActiveData.prevQualArtProgetto
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Qualità artistica del progetto"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="7" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevInnovatRischio" class="h5">Innovatività dei progetti e assunzione del rischio culturale</label>
                          <ejs-numerictextbox id="prevInnovatRischio" v-model="punteggiMinisteroActiveData.prevInnovatRischio
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Innovatività dei progetti e assunzione del rischio culturale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="7" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCorsiConcorsi" class="h5">Organizzazione di corsi e concorsi</label>
                          <ejs-numerictextbox id="prevCorsiConcorsi" v-model="punteggiMinisteroActiveData.prevCorsiConcorsi
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Organizzazione di corsi e concorsi"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevMultidisc" class="h5">Multidisciplinarietà dei progetti</label>
                          <ejs-numerictextbox id="prevMultidisc" v-model="punteggiMinisteroActiveData.prevMultidisc
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Multidisciplinarietà dei progetti"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevEducPromoPubbl" class="h5">Interventi di educazione e promozione presso il pubblico a carattere continuativo</label>
                          <ejs-numerictextbox id="prevEducPromoPubbl" v-model="punteggiMinisteroActiveData.prevEducPromoPubbl
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Interventi di educazione e promozione presso il pubblico a carattere continuativo"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="5" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevApertContStrutt" class="h5">Apertura Continuativa delle strutture gestite</label>
                          <ejs-numerictextbox id="prevApertContStrutt" v-model="punteggiMinisteroActiveData.prevApertContStrutt
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Apertura Continuativa delle strutture gestite"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevContinSoggAffidGest" class="h5">Continuità pluriennale del soggetto e affidabilità gestionale, strategie 2030</label>
                          <ejs-numerictextbox id="prevContinSoggAffidGest" v-model="punteggiMinisteroActiveData.prevContinSoggAffidGest
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Continuità pluriennale del soggetto e affidabilità gestionale, strategie 2030"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevPartFestival" class="h5">Partecipazione a festival</label>
                          <ejs-numerictextbox id="prevPartFestival" v-model="punteggiMinisteroActiveData.prevPartFestival
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Partecipazione a festival"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevStratComunic" class="h5">Strategia di comunicazione</label>
                          <ejs-numerictextbox id="prevStratComunic" v-model="punteggiMinisteroActiveData.prevStratComunic
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Strategia di comunicazione"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevIntegrStruttCult" class="h5">Integrazione con strutture e attività del sistema culturale</label>
                          <ejs-numerictextbox id="prevIntegrStruttCult" v-model="punteggiMinisteroActiveData.prevIntegrStruttCult
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Integrazione con strutture e attività del sistema culturale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevRetiNazInternaz" class="h5">Sviluppo, creazione e partecipazione a reti nazionali e internazionali</label>
                          <ejs-numerictextbox id="prevRetiNazInternaz" v-model="punteggiMinisteroActiveData.prevRetiNazInternaz
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Sviluppo, creazione e partecipazione a reti nazionali e internazionali"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                       
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotaleQualitaArtistica" class="h5">TOTALE TABELLA QUALITA' ARTISTICA</label>
                          <ejs-numerictextbox id="prevTotaleQualitaArtistica" v-model="prevTotaleQualitaArtistica" floatLabelType="Never"
                            cssClass="" format="###" placeholder="Totale Entrate" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>TABELLA BASE QUANTITATIVA - PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Tabella Base Quantitativa</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevGiornLavor" class="h5">Giornate lavorative</label>
                          <ejs-numerictextbox id="prevGiornLavor" v-model="punteggiMinisteroActiveData.prevGiornLavor
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Giornate lavorative"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="8" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevOneriSociali" class="h5">Oneri sociali</label>
                          <ejs-numerictextbox id="prevOneriSociali" v-model="punteggiMinisteroActiveData.prevOneriSociali
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Oneri sociali"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="8" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevReciteConcRappr" class="h5">Recite, concerti, rappresentazioni</label>
                          <ejs-numerictextbox id="prevReciteConcRappr" v-model="punteggiMinisteroActiveData.prevReciteConcRappr
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Recite, concerti, rappresentazioni"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="16" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSpettatori" class="h5">Spettatori</label>
                          <ejs-numerictextbox id="prevSpettatori" v-model="punteggiMinisteroActiveData.prevSpettatori
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Spettatori"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="8" />
                        </b-col>
                       
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotaleBaseQuantitativa" class="h5">TOTALE TABELLA BASE QUANTITATIVA</label>
                          <ejs-numerictextbox id="prevTotaleBaseQuantitativa" v-model="prevTotaleBaseQuantitativa" floatLabelType="Never"
                            cssClass="" format="###" placeholder="Totale Uscite" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>TABELLA QUALITA' INDICIZZATA - PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Tabella Qualità Indicizzata</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevTassoUtilSale" class="h5">Tasso di utilizzo delle sale</label>
                          <ejs-numerictextbox id="prevTassoUtilSale" v-model="punteggiMinisteroActiveData.prevTassoUtilSale
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Tasso di utilizzo delle sale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAmplPubblico" class="h5">Ampliamento del pubblico</label>
                          <ejs-numerictextbox id="prevAmplPubblico" v-model="punteggiMinisteroActiveData.prevAmplPubblico
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Ampliamento del pubblico"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSvilOffTerrSvant" class="h5">Sviluppo dell'offerta in territori svantaggiati</label>
                          <ejs-numerictextbox id="prevSvilOffTerrSvant" v-model="punteggiMinisteroActiveData.prevSvilOffTerrSvant
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Sviluppo dell'offerta in territori svantaggiati"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevSvilOffPiccCentri" class="h5">Sviluppo dell'offerta nei piccoli centri</label>
                          <ejs-numerictextbox id="prevSvilOffPiccCentri" v-model="punteggiMinisteroActiveData.prevSvilOffPiccCentri
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Sviluppo dell'offerta nei piccoli centri"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevAmplProgramm" class="h5">Ampliamento della programmazione</label>
                          <ejs-numerictextbox id="prevAmplProgramm" v-model="punteggiMinisteroActiveData.prevAmplProgramm
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Ampliamento della programmazione"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCapRepRisNonPubbl" class="h5">Capacità di reperire risorse non pubbliche</label>
                          <ejs-numerictextbox id="prevCapRepRisNonPubbl" v-model="punteggiMinisteroActiveData.prevCapRepRisNonPubbl
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Capacità di reperire risorse non pubbliche"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="4" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCapRepAltreRisPubbl" class="h5">Capacità di reperire altre risorse pubbliche</label>
                          <ejs-numerictextbox id="prevCapRepAltreRisPubbl" v-model="punteggiMinisteroActiveData.prevCapRepAltreRisPubbl
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Capacità di reperire altre risorse pubbliche"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevEfficGest" class="h5">Efficienza gestionale</label>
                          <ejs-numerictextbox id="prevEfficGest" v-model="punteggiMinisteroActiveData.prevEfficGest
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Efficienza gestionale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevPartProgCofinUE" class="h5">Partecipazione a progetti cofinanziati dalla UE</label>
                          <ejs-numerictextbox id="prevPartProgCofinUE" v-model="punteggiMinisteroActiveData.prevPartProgCofinUE
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Partecipazione a progetti cofinanziati dalla UE"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="prevCoprodNazInternaz" class="h5">Coproduzioni nazionali e internazionali</label>
                          <ejs-numerictextbox id="prevCoprodNazInternaz" v-model="punteggiMinisteroActiveData.prevCoprodNazInternaz
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Coproduzioni nazionali e internazionali"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="5" />
                        </b-col>
                       
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotaleQualitaIndicizzata" class="h5">TOTALE TABELLA QUALITA' INDICIZZATA</label>
                          <ejs-numerictextbox id="prevTotaleQualitaIndicizzata" v-model="prevTotaleQualitaIndicizzata" floatLabelType="Never"
                            cssClass="" format="###" placeholder="Totale Uscite" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>TOTALE PUNTEGGI MINISTERO - PREVENTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title></b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="prevTotalePunteggi" class="h5">TOTALE PUNTEGGI</label>
                          <ejs-numerictextbox id="prevTotalePunteggi" v-model="prevTotalePunteggi" floatLabelType="Never" cssClass=""
                            format="###" placeholder="Deficit" showSpinButton="false" showClearButton="true"
                            :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab title="PUNTEGGI MINISTERO CONSUNTIVO" @click="tabClicked('tab02')">
              <b-row class="match-height">
                <b-col xl="12" md="12">
                  <h3>&nbsp</h3>
                  <h3>TABELLA QUALITA' ARTISTICA - CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Tabella Qualità Artistica</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>

                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consQualDirezArt" class="h5">Qualità della direzione artistica</label>
                          <ejs-numerictextbox id="consQualDirezArt" v-model="punteggiMinisteroActiveData.consQualDirezArt
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Qualità della direzione artistica"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consQualPersArt" class="h5">Qualità professionale del personale artistico e/o degli artisti ospitati</label>
                          <ejs-numerictextbox id="consQualPersArt" v-model="punteggiMinisteroActiveData.consQualPersArt
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Qualità professionale del personale artistico e/o degli artisti ospitati"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consQualArtProgetto" class="h5">Qualità artistica del progetto</label>
                          <ejs-numerictextbox id="consQualArtProgetto" v-model="punteggiMinisteroActiveData.consQualArtProgetto
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Qualità artistica del progetto"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="7" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consInnovatRischio" class="h5">Innovatività dei progetti e assunzione del rischio culturale</label>
                          <ejs-numerictextbox id="consInnovatRischio" v-model="punteggiMinisteroActiveData.consInnovatRischio
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Innovatività dei progetti e assunzione del rischio culturale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="7" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCorsiConcorsi" class="h5">Organizzazione di corsi e concorsi</label>
                          <ejs-numerictextbox id="consCorsiConcorsi" v-model="punteggiMinisteroActiveData.consCorsiConcorsi
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Organizzazione di corsi e concorsi"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consMultidisc" class="h5">Multidisciplinarietà dei progetti</label>
                          <ejs-numerictextbox id="consMultidisc" v-model="punteggiMinisteroActiveData.consMultidisc
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Multidisciplinarietà dei progetti"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consEducPromoPubbl" class="h5">Interventi di educazione e promozione presso il pubblico a carattere continuativo</label>
                          <ejs-numerictextbox id="consEducPromoPubbl" v-model="punteggiMinisteroActiveData.consEducPromoPubbl
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Interventi di educazione e promozione presso il pubblico a carattere continuativo"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="5" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consApertContStrutt" class="h5">Apertura Continuativa delle strutture gestite</label>
                          <ejs-numerictextbox id="consApertContStrutt" v-model="punteggiMinisteroActiveData.consApertContStrutt
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Apertura Continuativa delle strutture gestite"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consContinSoggAffidGest" class="h5">Continuità pluriennale del soggetto e affidabilità gestionale, strategie 2030</label>
                          <ejs-numerictextbox id="consContinSoggAffidGest" v-model="punteggiMinisteroActiveData.consContinSoggAffidGest
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Continuità pluriennale del soggetto e affidabilità gestionale, strategie 2030"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consPartFestival" class="h5">Partecipazione a festival</label>
                          <ejs-numerictextbox id="consPartFestival" v-model="punteggiMinisteroActiveData.consPartFestival
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Partecipazione a festival"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consStratComunic" class="h5">Strategia di comunicazione</label>
                          <ejs-numerictextbox id="consStratComunic" v-model="punteggiMinisteroActiveData.consStratComunic
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Strategia di comunicazione"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consIntegrStruttCult" class="h5">Integrazione con strutture e attività del sistema culturale</label>
                          <ejs-numerictextbox id="consIntegrStruttCult" v-model="punteggiMinisteroActiveData.consIntegrStruttCult
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Integrazione con strutture e attività del sistema culturale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consRetiNazInternaz" class="h5">Sviluppo, creazione e partecipazione a reti nazionali e internazionali</label>
                          <ejs-numerictextbox id="consRetiNazInternaz" v-model="punteggiMinisteroActiveData.consRetiNazInternaz
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Sviluppo, creazione e partecipazione a reti nazionali e internazionali"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                       
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotaleQualitaArtistica" class="h5">TOTALE TABELLA QUALITA' ARTISTICA</label>
                          <ejs-numerictextbox id="consTotaleQualitaArtistica" v-model="consTotaleQualitaArtistica" floatLabelType="Never"
                            cssClass="" format="###" placeholder="Totale Entrate" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>TABELLA BASE QUANTITATIVA - CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Tabella Base Quantitativa</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consGiornLavor" class="h5">Giornate lavorative</label>
                          <ejs-numerictextbox id="consGiornLavor" v-model="punteggiMinisteroActiveData.consGiornLavor
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Giornate lavorative"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="8" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consOneriSociali" class="h5">Oneri sociali</label>
                          <ejs-numerictextbox id="consOneriSociali" v-model="punteggiMinisteroActiveData.consOneriSociali
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Oneri sociali"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="8" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consReciteConcRappr" class="h5">Recite, concerti, rappresentazioni</label>
                          <ejs-numerictextbox id="consReciteConcRappr" v-model="punteggiMinisteroActiveData.consReciteConcRappr
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Recite, concerti, rappresentazioni"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="16" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSpettatori" class="h5">Spettatori</label>
                          <ejs-numerictextbox id="consSpettatori" v-model="punteggiMinisteroActiveData.consSpettatori
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Spettatori"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="8" />
                        </b-col>
                       
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotaleBaseQuantitativa" class="h5">TOTALE TABELLA BASE QUANTITATIVA</label>
                          <ejs-numerictextbox id="consTotaleBaseQuantitativa" v-model="consTotaleBaseQuantitativa" floatLabelType="Never"
                            cssClass="" format="###" placeholder="Totale Uscite" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>TABELLA QUALITA' INDICIZZATA - CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title>Tabella Qualità Indicizzata</b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consTassoUtilSale" class="h5">Tasso di utilizzo delle sale</label>
                          <ejs-numerictextbox id="consTassoUtilSale" v-model="punteggiMinisteroActiveData.consTassoUtilSale
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Tasso di utilizzo delle sale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAmplPubblico" class="h5">Ampliamento del pubblico</label>
                          <ejs-numerictextbox id="consAmplPubblico" v-model="punteggiMinisteroActiveData.consAmplPubblico
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Ampliamento del pubblico"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSvilOffTerrSvant" class="h5">Sviluppo dell'offerta in territori svantaggiati</label>
                          <ejs-numerictextbox id="consSvilOffTerrSvant" v-model="punteggiMinisteroActiveData.consSvilOffTerrSvant
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Sviluppo dell'offerta in territori svantaggiati"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consSvilOffPiccCentri" class="h5">Sviluppo dell'offerta nei piccoli centri</label>
                          <ejs-numerictextbox id="consSvilOffPiccCentri" v-model="punteggiMinisteroActiveData.consSvilOffPiccCentri
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Sviluppo dell'offerta nei piccoli centri"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consAmplProgramm" class="h5">Ampliamento della programmazione</label>
                          <ejs-numerictextbox id="consAmplProgramm" v-model="punteggiMinisteroActiveData.consAmplProgramm
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Ampliamento della programmazione"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="3" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCapRepRisNonPubbl" class="h5">Capacità di reperire risorse non pubbliche</label>
                          <ejs-numerictextbox id="consCapRepRisNonPubbl" v-model="punteggiMinisteroActiveData.consCapRepRisNonPubbl
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Capacità di reperire risorse non pubbliche"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="4" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCapRepAltreRisPubbl" class="h5">Capacità di reperire altre risorse pubbliche</label>
                          <ejs-numerictextbox id="consCapRepAltreRisPubbl" v-model="punteggiMinisteroActiveData.consCapRepAltreRisPubbl
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Capacità di reperire altre risorse pubbliche"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consEfficGest" class="h5">Efficienza gestionale</label>
                          <ejs-numerictextbox id="consEfficGest" v-model="punteggiMinisteroActiveData.consEfficGest
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Efficienza gestionale"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="2" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consPartProgCofinUE" class="h5">Partecipazione a progetti cofinanziati dalla UE</label>
                          <ejs-numerictextbox id="consPartProgCofinUE" v-model="punteggiMinisteroActiveData.consPartProgCofinUE
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Partecipazione a progetti cofinanziati dalla UE"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="1" />
                        </b-col>
                        <b-col xl="4" md="4" class="mb-2">
                          <label for="consCoprodNazInternaz" class="h5">Coproduzioni nazionali e internazionali</label>
                          <ejs-numerictextbox id="consCoprodNazInternaz" v-model="punteggiMinisteroActiveData.consCoprodNazInternaz
                  " floatLabelType="Never" cssClass="" format="###" placeholder="Coproduzioni nazionali e internazionali"
                            showSpinButton="false" showClearButton="true" :step="1" :min="0" :max="5" />
                        </b-col>
                       
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotaleQualitaIndicizzata" class="h5">TOTALE TABELLA QUALITA' INDICIZZATA</label>
                          <ejs-numerictextbox id="consTotaleQualitaIndicizzata" v-model="consTotaleQualitaIndicizzata" floatLabelType="Never"
                            cssClass="" format="###" placeholder="Totale Uscite" showSpinButton="false"
                            showClearButton="true" :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>

                  <h3>&nbsp</h3>
                  <h3>TOTALE PUNTEGGI MINISTERO - CONSUNTIVO</h3>
                  <h3>&nbsp</h3>
                  <b-card tag="article" class="mb-2">
                    <b-card-header class="align-items-baseline">
                      <div>
                        <b-card-title></b-card-title>
                        <b-card-text class="mb-0" />
                      </div>
                    </b-card-header>
                    <b-card-body class="mb-0">
                      <!-- card body -->
                      <b-row>
                        <b-col xl="12" md="12" class="mb-2">
                          <label for="consTotalePunteggi" class="h5">TOTALE PUNTEGGI</label>
                          <ejs-numerictextbox id="consTotalePunteggi" v-model="consTotalePunteggi" floatLabelType="Never" cssClass=""
                            format="###" placeholder="Deficit" showSpinButton="false" showClearButton="true"
                            :readonly="true" />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
      </b-col>
      <b-col xl="12" md="12" class="text-right mt-1" v-show="showTabsPunteggi">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title></b-card-title>
              <b-card-text class="mb-0" />
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <b-row>
              <b-col xl="4" md="4">
                <ejs-button id="creaPunteggiMinisteroButton" cssClass="e-flat"
                  @click.native="salvaPunteggiMinisteroButton()">SALVA I PUNTEGGI CORRENTI
                </ejs-button>
              </b-col>
              <!-- temporaneamente nascosto
              <b-col xl="4" md="4">
                <ejs-button id="importaVociRegContabiliButton" cssClass="e-flat"
                  @click.native="importaVociRegContabili()">IMPORTA VOCI CONSUNTIVO DA REG. CONTABILI
                </ejs-button>
              </b-col> -->
              <!-- temporaneamente nascosto
              <b-col xl="4" md="4">
                <ejs-button id="exportaVociRegContabiliButton" cssClass="e-flat"
                  @click.native="esportaVociRegContabili()">ESPORTA PUNTEGGIO IN EXCEL
                </ejs-button>
              </b-col> -->
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import useJwt from "@/auth/jwt/useJwt";
// import bootstrap-Vue
import {
  LayoutPlugin,
  TabsPlugin,
  CardPlugin,
  DropdownPlugin,
  ImagePlugin,
  LinkPlugin,
  AlertPlugin,
  ToastPlugin,
  SpinnerPlugin,
} from "bootstrap-vue";
// import Vuexy

// import Syncfusion
import { enableRipple } from "@syncfusion/ej2-base";
import { Query } from "@syncfusion/ej2-data";
import {
  DateTimePickerPlugin,
  DateRangePickerPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
} from "@syncfusion/ej2-vue-calendars";
import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from "@syncfusion/ej2-vue-buttons";
import {
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin,
} from "@syncfusion/ej2-vue-inputs";
import {
  DropDownListPlugin,
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import {
  GridPlugin,
  Aggregate,
  Group,
  ForeignKey,
  Edit as GridEdit,
  Toolbar as GridToolbar,
  Sort as GridSort,
  Filter as GridFilter,
} from "@syncfusion/ej2-vue-grids";
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

const axios = require("axios");
// use bootstrap-vue
Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(ImagePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(SpinnerPlugin);
// use Syncfusion
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
enableRipple(true);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT;
const apiPunteggiMinisteroUrl = "/demo/api/punteggiministero";
const apiPunteggiMinisteroRicercaUrl = "/demo/api/punteggiministero/ricercaAnno";

var itemVue = Vue.component("itemTemplate", {
  template: `<span><span class='ragioneSociale'>{{data.ragioneSociale}}</span><span style='margin-right:3em;display:inline-block;'>&nbsp;&nbsp;</span><span class ='partitaIva'>{{data.partitaIva}}</span></span>`,
  data() {
    return {
      data: {},
    };
  },
});

export default Vue.extend({
  components: {},
  data() {
    return {
      loading: false,
      // per gestione anni
      anniData: [
        { label: "Anno 2019", val: "2019" },
        { label: "Anno 2020", val: "2020" },
        { label: "Anno 2021", val: "2021" },
        { label: "Anno 2022", val: "2022" },
        { label: "Anno 2023", val: "2023" },
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
        { label: "Anno 2027", val: "2027" },
      ],
      anniFields: { value: "val", text: "label" },
      anniIndex: -1,
      queryAnni: null,
      annoCorrente: null,

      // gestione elementi nascosti
      nonMostrare: false,
      itemTemplate: function () {
        return { template: itemVue };
      },
      valueTemplate: function () {
        return { template: itemVue };
      },

      // generali
      settings: {
        formatoData: "dd-MM-yyyy",
        formatoOra: "HH:mm",
        intervalloOra: 15,
        firstDayOfWeek: 1,
      },
      // punteggiMinistero
      punteggiMinisteroFullData: [], // elenco completo dati punteggiMinistero
      punteggiMinisteroActiveId: 0, // Id punteggiMinistero attivo (0 se nuovo)
      punteggiMinisteroActiveData: {}, // dati completi del punteggiMinistero attivo
      punteggiMinisteroSavedData: {}, // dati completi del punteggiMinistero attivo
      punteggiMinisteroDefaultData: {}, // dati completi di default per nuovi punteggiMinistero

      // fornitori
      fornitoriList: [],
      fornitoriFields: { text: "ragioneSociale", value: "id" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per bottoneCreazionepunteggiMinistero
      showButtonCreatePunteggi: false,

      // per tabA
      tabAIndex: null,

      // per showTabsPunteggi
      showTabsPunteggi: false,
    };
  },
  created() {
    // log
    console.log("Pagina punteggiMinistero Creata");
    // inizializzazione elenchi dal backend
    // chiamate API

    // TODO gestione status 401 con redirect a login
    if (localStorage.getItem("userData") !== null) {
      console.log("Recupero elenchi dal backend");

      // punteggiMinisteroFullData
      // recupero elenco punteggiMinistero dal backend
      console.log("Recupero elenco punteggiMinistero dal backend");
    } else {
      console.log("Non trovo UserData, prova ancora");
    }
  },
  mounted() {
    // focus su dropAnni
    this.$refs.dropAnni.ej2Instances.focusIn();
  },

  provide: {
    // per grid
    grid: [
      GridToolbar,
      GridSort,
      GridFilter,
      GridEdit,
      ForeignKey,
      Group,
      Aggregate,
    ],
  },
  methods: {
    creaPunteggiMinisteroButton: function () {
      console.log("Creazione nuovo PUNTEGGI MINISTERO");

      // salvataggio in caso di new

      this.punteggiMinisteroActiveData = { id: 0, anno: this.annoCorrente };

      useJwt
        .post(apiPunteggiMinisteroUrl, this.punteggiMinisteroActiveData)
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            this.makeToast(
              "primary",
              "Successo",
              "Creazione del punteggiMinistero"
            );
          }
          console.log(res.status);
          console.log(res.data);
          // mi segno ID elemento appena creato
          this.punteggiMinisteroActiveId = res.data.id;
          return this; // restituisci contesto per permettere aggiornamento gridA
        });
      // .then((context) => {
      //   useJwt.get(apiPunteggiMinisteroUrl).then((d) => {
      //     // gestione risposta
      //     console.log("Aggiornamento gridA con l'aggiunta di una scrittura");
      //     console.log(d.data);
      //     context.punteggiMinisteroFullData = d.data;
      //     context.punteggiMinisteroFullData = [
      //       ...context.punteggiMinisteroFullData,
      //     ];
      //   });
      // });

      this.showButtonCreatePunteggi = false;
    },
    salvaPunteggiMinisteroButton: function () {
      console.log("Salvataggio in Edit PUNTEGGI MINISTERO");

      // salvataggio in caso di edit

      // salvo i field computed
      this.punteggiMinisteroActiveData.prevTotaleQualitaArtistica = this.prevTotaleQualitaArtistica;
      this.punteggiMinisteroActiveData.prevTotaleBaseQuantitativa = this.prevTotaleBaseQuantitativa;
      this.punteggiMinisteroActiveData.prevTotaleQualitaIndicizzata = this.prevTotaleQualitaIndicizzata;
      this.punteggiMinisteroActiveData.prevTotalePunteggi = this.prevTotalePunteggi;

      this.punteggiMinisteroActiveData.consTotaleQualitaArtistica = this.consTotaleQualitaArtistica;
      this.punteggiMinisteroActiveData.consTotaleBaseQuantitativa = this.consTotaleBaseQuantitativa;
      this.punteggiMinisteroActiveData.consTotaleQualitaIndicizzata = this.consTotaleQualitaIndicizzata;
      this.punteggiMinisteroActiveData.consTotalePunteggi = this.consTotalePunteggi;

      //this.punteggiMinisteroActiveData = { id: 0, anno: this.annoCorrente };
      const editUrl = `${apiPunteggiMinisteroUrl}/${this.punteggiMinisteroActiveId}`;

      this.punteggiMinisteroActiveData['anno'] = this.annoCorrente
      useJwt.patch(editUrl, this.punteggiMinisteroActiveData).then((res) => {
        if (res.status == 200 || res.status == 201) {
          this.makeToast(
            "primary",
            "Successo",
            "Modifica del PUNTEGGI MINISTERO eseguita con successo"
          );
        } else {
          this.makeToast(
            "primary",
            "ERRORE",
            "Errore nel salvataggio PUNTEGGI MINISTERO"
          );

        }
        console.log(res.status);
        console.log(res.data);
        // mi segno ID elemento appena creato
        this.punteggiMinisteroActiveId = res.data.id;
        return this; // restituisci contesto per permettere aggiornamento gridA
      });
      // .then((context) => {
      //   useJwt.get(apiPunteggiMinisteroUrl).then((d) => {
      //     // gestione risposta
      //     console.log("Aggiornamento gridA con l'aggiunta di una scrittura");
      //     console.log(d.data);
      //     context.punteggiMinisteroFullData = d.data;
      //     context.punteggiMinisteroFullData = [
      //       ...context.punteggiMinisteroFullData,
      //     ];
      //   });
      // });

      this.showButtonCreatePunteggi = false;
    },
    // onAnnoChange
    async onAnnoChange (e) {
      this.loading = true;
      console.log("Recupero elenco punteggiMinistero dal backend");
      const datiDaInviare = {
        anno: this.annoCorrente,
      };
      if (datiDaInviare.anno === null) {
        console.log("Anno non ancora selezionato");
      } else {
        // recupero il PUNTEGGI MINISTERO salvato con quell'anno se esistente
        const r = await useJwt.post(apiPunteggiMinisteroRicercaUrl, datiDaInviare).then((d) => {
          // gestione risposta
          //this.punteggiMinisteroActiveData = d.data;
          console.log("PUNTEGGI MINISTERO collegato:");
          //console.log(this.punteggiMinisteroActiveData);
          //console.log(this.punteggiMinisteroActiveData.length);
          this.loading = false;
          console.log(d.data)

          if (d.data['error'] == false) {
            this.punteggiMinisteroActiveData = d.data;
            this.punteggiMinisteroActiveId = d.data.id;
            // abilito tabs e disabilito bottone create
            this.showTabsPunteggi = true;
            this.showButtonCreatePunteggi = false;
            console.log("punteggiMinisteroActiveData");
            console.log(this.punteggiMinisteroActiveData);
            console.log(this.punteggiMinisteroActiveData.anno);

            // context.punteggiMinisteroFullData = d.data;
            // context.punteggiMinisteroFullData = [
            //   ...context.punteggiMinisteroFullData,
            // ];
            return false
          } else {
            console.log(
              "Non esiste ancora un PUNTEGGI MINISTERO per l'anno selezionato"
            );
            this.punteggiMinisteroActiveData = {};
            // disabilito tabs e abilito bottone create
            this.showTabsPunteggi = false;
            this.showButtonCreatePunteggi = true;
            return true
          }
        });
        if (r) {
          this.makeToast(
            "primary",
            "Attenzione",
            "Bilancio mancante per l'anno selezionato"
          );
        }
      }
    },

    // per click tabs
    tabClicked(args) {
      switch (args) {
        case "tab01":
          console.log("Sei nel primo tab");
          break;
        case "tab02":
          console.log("Sei nel secondo tab");
          break;
        default:
          console.log(args);
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown;
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs;
    },
    // per toast
    makeToast(variant = null, title = "titolo", message = "messaggio") {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      });
    },
    noop() {
      console.log("premuto enter");
    },
  },
  computed: {
    hasChanged() {
      // console.log(this.punteggiMinisteroActiveData)
      // console.log(this.punteggiMinisteroSavedData)
      return Object.keys(this.punteggiMinisteroActiveData).some(
        (field) =>
          this.punteggiMinisteroActiveData[field] !==
          this.punteggiMinisteroSavedData[field]
      );
    },
    prevTotaleQualitaArtistica: {
      get: function () {
        return (
          this.punteggiMinisteroActiveData.prevQualDirezArt +
          this.punteggiMinisteroActiveData.prevQualPersArt +
          this.punteggiMinisteroActiveData.prevQualArtProgetto +
          this.punteggiMinisteroActiveData.prevInnovatRischio +
          this.punteggiMinisteroActiveData.prevCorsiConcorsi +
          this.punteggiMinisteroActiveData.prevMultidisc +
          this.punteggiMinisteroActiveData.prevEducPromoPubbl +
          this.punteggiMinisteroActiveData.prevApertContStrutt +
          this.punteggiMinisteroActiveData.prevContinSoggAffidGest +
          this.punteggiMinisteroActiveData.prevPartFestival +
          this.punteggiMinisteroActiveData.prevStratComunic +
          this.punteggiMinisteroActiveData.prevIntegrStruttCult +
          this.punteggiMinisteroActiveData.prevRetiNazInternaz
        );
      },
      set: function () {
        // non usato
      },
    },
    prevTotaleBaseQuantitativa: {
      get: function () {
        return (
          this.punteggiMinisteroActiveData.prevGiornLavor +
          this.punteggiMinisteroActiveData.prevOneriSociali +
          this.punteggiMinisteroActiveData.prevReciteConcRappr +
          this.punteggiMinisteroActiveData.prevSpettatori
        );
      },
      set: function () {
        // non usato
      },
    },
    prevTotaleQualitaIndicizzata: {
      get: function () {
        return (
          this.punteggiMinisteroActiveData.prevTassoUtilSale +
          this.punteggiMinisteroActiveData.prevAmplPubblico +
          this.punteggiMinisteroActiveData.prevSvilOffTerrSvant +
          this.punteggiMinisteroActiveData.prevSvilOffPiccCentri +
          this.punteggiMinisteroActiveData.prevAmplProgramm +
          this.punteggiMinisteroActiveData.prevCapRepRisNonPubbl +
          this.punteggiMinisteroActiveData.prevCapRepAltreRisPubbl +
          this.punteggiMinisteroActiveData.prevEfficGest +
          this.punteggiMinisteroActiveData.prevPartProgCofinUE +
          this.punteggiMinisteroActiveData.prevCoprodNazInternaz 
        );
      },
      set: function () {
        // not usato
      },
    },
    prevTotalePunteggi: {
      get: function () {
        return this.prevTotaleQualitaArtistica + this.prevTotaleBaseQuantitativa + this.prevTotaleQualitaIndicizzata;
      },
      set: function () {
        // non usato
      },
    },
    consTotaleQualitaArtistica: {
      get: function () {
        return (
          this.punteggiMinisteroActiveData.consQualDirezArt +
          this.punteggiMinisteroActiveData.consQualPersArt +
          this.punteggiMinisteroActiveData.consQualArtProgetto +
          this.punteggiMinisteroActiveData.consInnovatRischio +
          this.punteggiMinisteroActiveData.consCorsiConcorsi +
          this.punteggiMinisteroActiveData.consMultidisc +
          this.punteggiMinisteroActiveData.consEducPromoPubbl +
          this.punteggiMinisteroActiveData.consApertContStrutt +
          this.punteggiMinisteroActiveData.consContinSoggAffidGest +
          this.punteggiMinisteroActiveData.consPartFestival +
          this.punteggiMinisteroActiveData.consStratComunic +
          this.punteggiMinisteroActiveData.consIntegrStruttCult +
          this.punteggiMinisteroActiveData.consRetiNazInternaz
        );
      },
      set: function () {
        // non usato
      },
    },
    consTotaleBaseQuantitativa: {
      get: function () {
        return (
          this.punteggiMinisteroActiveData.consGiornLavor +
          this.punteggiMinisteroActiveData.consOneriSociali +
          this.punteggiMinisteroActiveData.consReciteConcRappr +
          this.punteggiMinisteroActiveData.consSpettatori
        );
      },
      set: function () {
        // non usato
      },
    },
    consTotaleQualitaIndicizzata: {
      get: function () {
        return (
          this.punteggiMinisteroActiveData.consTassoUtilSale +
          this.punteggiMinisteroActiveData.consAmplPubblico +
          this.punteggiMinisteroActiveData.consSvilOffTerrSvant +
          this.punteggiMinisteroActiveData.consSvilOffPiccCentri +
          this.punteggiMinisteroActiveData.consAmplProgramm +
          this.punteggiMinisteroActiveData.consCapRepRisNonPubbl +
          this.punteggiMinisteroActiveData.consCapRepAltreRisPubbl +
          this.punteggiMinisteroActiveData.consEfficGest +
          this.punteggiMinisteroActiveData.consPartProgCofinUE +
          this.punteggiMinisteroActiveData.consCoprodNazInternaz 
        );
      },
      set: function () {
        // not usato
      },
    },
    consTotalePunteggi: {
      get: function () {
        return this.consTotaleQualitaArtistica + this.consTotaleBaseQuantitativa + this.consTotaleQualitaIndicizzata;
      },
      set: function () {
        // non usato
      },
    },
    
  },
});

/* eslint-disable global-require */
</script>

<style lang="scss">
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/material.css";
@import "~@syncfusion/ej2-calendars/styles/datepicker/material.css";
@import "~@syncfusion/ej2-dropdowns/styles/material.css";
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import "~@syncfusion/ej2-inputs/styles/material.css";
@import "~@syncfusion/ej2-vue-layouts/styles/material.css";
@import "~@syncfusion/ej2-vue-richtexteditor/styles/material.css";
@import "~@syncfusion/ej2-splitbuttons/styles/material.css";
@import "~@syncfusion/ej2-grids/styles/material.css";

.e-btn-icon.e-open-icon {
  background: url("~@/assets/images/svg/open2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url("~@/assets/images/svg/garbage-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url("~@/assets/images/svg/download2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url("~@/assets/images/svg/search-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url("~@/assets/images/svg/upload-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url("~@/assets/images/svg/add2-svgrepo-com.svg");
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
